<template>
  <div>
    <DevNotes>
      LiveClass : 0%
      Development Notes
      - แสดงการ Live สด สำหรับอาจารย์ (เอาไว้ดูตัวเอง)
      Objectives:
      - Develop a port version with modular and readability refactoring with well improvement
    </DevNotes>

    <!-- <component :is="getCurrentStage().k" :classroomId="classroomId"/>  -->
    <component :is="getCurrentStage().k" />

  </div>
</template>

<script>
import { getCurrentStage } from "@/developing/dev-data";
import { bulkImportComponent } from "@/developing/utils/modular";

export default {
  components: {
    DevNotes: () => import("@/developing/dev-components/DevNotes"),
    ...bulkImportComponent("components/liveclass")
  },
  props: {
    classroomId: {
      type: String,
      default: null
    }
  },
  watch: {
    // "classroomId": function (curr, prev) {
    //   if (curr !== prev) this.$forceUpdate();
    // }
  },
  methods: {
    getCurrentStage,
  },
  // beforeCreate() {
  //   if (!this.$store.state.ClassroomStats) this.$store.registerModule(StoreModuleName, StoreModule);
  // },
  // destroyed() {
  //   this.$store.unregisterModule(StoreModuleName);
  // },
  mounted() {
    // console.log(this);
    // console.log(bulkImportComponent("components/liveclass"));
  }
}
</script>
